import React, { useContext, useEffect, useMemo, useState } from "react";
import { getProductBySearchKeywords } from "../../helper/backend-methods";
import debounce from "lodash/debounce";
import { useCallback } from "react";
import { GlobalContext } from "../../context";

export default function SearchComponent({ allItems }) {
  const [query, setQuery] = useState("");
  const { updateProducts,updateQuery  } = useContext(GlobalContext);
  const suggestions = useMemo(() => {
    if (!query) return [];
    return allItems
      .filter(item => item.ProductName?.toLowerCase().includes(query.toLowerCase()))
      .slice(0, 5);
  }, [query, allItems]);


  const suggestionCategory = useMemo(() => {
    if (!query) return [];
    let fiterItems = allItems
      .filter(item => item.CategoryName?.toLowerCase().includes(query.toLowerCase()))
      .slice(0, 5);
    let distinctCategories = [...new Set(fiterItems.map(item => item.CategoryName))];
    console.log(distinctCategories);
    return distinctCategories;
  }, [query]);

  const debouncedSearch = useCallback(
    debounce((value) => {
      if (!value || value.length < 2) return;
      getProductBySearchKeywords({ globalSearch: value })
        .then(({ data }) => {
          if (data.Status) {
            let _products = data.Data.map((p) => {

              let item = p.ProductDetails;
              item.productAttributes = p.ProductAttributes;
              return item;
            })
            updateQuery(value);
            updateProducts(_products);
          }
        });
    }, 300),
    []
  );

  useEffect(() => {
    return () => debouncedSearch.cancel();
  }, [debouncedSearch]);

  const handleChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    debouncedSearch(value);
  };

  const handleSuggestionClick = (title) => {
    setQuery(title);
    debouncedSearch(title);
  };


  return (
    <div className="search-section">
      <div className="position-relative">
        <svg className="menu-search-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="rgba(26,26,26,1)">
          <path d="M18.031 16.6168L22.3137 20.8995L20.8995 22.3137L16.6168 18.031C15.0769 19.263 13.124 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20 13.124 19.263 15.0769 18.031 16.6168ZM16.0247 15.8748C17.2475 14.6146 18 12.8956 18 11C18 7.1325 14.8675 4 11 4C7.1325 4 4 7.1325 4 11C4 14.8675 7.1325 18 11 18C12.8956 18 14.6146 17.2475 15.8748 16.0247L16.0247 15.8748Z"></path>
        </svg>
        <input
          type="text"
          placeholder="Search by item name, category or keyword"
          value={query}
          onChange={handleChange}
          className="manu-search-input"
        />
      </div>

      {query && (
        <div className="search-tags">

          {suggestionCategory.length > 0 ? (

            suggestionCategory.map((item) => (

              <span className="suggested-menu" key={item} onClick={() => handleSuggestionClick(item)}>
                <span className="hash-tag">#</span>
                <span>{item}</span>
              </span>
            ))
          ) : ""}


          {suggestions.length > 0 ? (

            suggestions.map((item) => (

              <span className="suggested-menu" key={item.ProductId} onClick={() => handleSuggestionClick(item.ProductName)}>
                <span className="hash-tag">#</span>
                <span>{item.ProductName}</span>
              </span>
            ))
          ) : ("")}
        </div>
      )}
    </div>
  );
}
